export const bspLeadActionTypes = {
	UPDATE_BSPLEAD: "UPDATE_BSPLEAD",
	INIT_BSPLEAD: "INIT_BSPLEAD",
};
